import createRequest from '@/utils/createRequest';

export default {
    install(VueInstance) {
        // eslint-disable-next-line no-param-reassign
        VueInstance.prototype.$req = createRequest;
    },
};
